import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import { Avatar, ButtonBase, CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { Check } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import MarkdownWrapper from "../MarkdownWrapper";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";

export default function TicketListItem({ ticket }) {
  const history = useHistory();
  const { ticketId } = useParams();
  const { user } = React.useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const pending = ticket.status === "pending";
  const selected = Number(ticketId) === ticket.id;
  const accept = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, { status: "open", userId: user.id });
      history.push(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };
  return <li className={`tw-flex tw-min-w-0 tw-items-center tw-border-0 motion-safe:tw-transition-colors tw-duration-200 tw-border-b tw-border-solid tw-border-slate-100 dark:tw-border-slate-800 ${selected ? "tw-bg-messenger-pale dark:tw-bg-[#233b2f]" : "hover:tw-bg-slate-50 dark:hover:tw-bg-[#172b22]"}`}>
    <ButtonBase disabled={loading} onClick={() => { if (!pending) history.push(`/tickets/${ticket.id}`); }} className="tw-group tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3 tw-px-4 tw-py-4 tw-text-left">
      <Avatar className="tw-h-12 tw-w-12 tw-shrink-0 motion-safe:tw-transition-transform tw-duration-200 motion-safe:group-hover:tw-scale-105 tw-bg-slate-300 tw-text-slate-600" src={ticket.contact.profilePicUrl}>{ticket.contact.name?.charAt(0)}</Avatar>
      <div className="tw-min-w-0 tw-flex-1">
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
          <strong className="tw-min-w-0 tw-truncate tw-text-sm tw-font-semibold">{ticket.contact.name}</strong>
          <span className="tw-shrink-0 tw-text-[11px] tw-text-slate-500 dark:tw-text-slate-400">{isSameDay(parseISO(ticket.updatedAt), new Date()) ? format(parseISO(ticket.updatedAt), "HH:mm") : format(parseISO(ticket.updatedAt), "dd/MM")}</span>
        </div>
        <div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-2">
          <span className="tw-min-w-0 tw-flex-1 tw-truncate tw-text-[13px] tw-text-slate-500 [&_p]:tw-m-0 [&_p]:tw-inline dark:tw-text-slate-400">{ticket.lastMessage && <MarkdownWrapper>{ticket.lastMessage}</MarkdownWrapper>}</span>
          {ticket.unreadMessages > 0 && <span className="tw-flex tw-h-5 tw-min-w-[20px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-messenger-green tw-px-1 tw-text-[11px] tw-text-white">{ticket.unreadMessages}</span>}
        </div>
        <div className="tw-mt-1.5 tw-flex tw-gap-1 tw-overflow-hidden">
          {[ticket.queue?.name, ticket.user?.name, ticket.channel === "portal" ? "Portal AlphaEduc" : ticket.whatsapp?.name].filter(Boolean).map((label, index) => <span key={index} title={label} className="tw-max-w-[110px] tw-truncate tw-rounded-full tw-bg-slate-100 tw-px-2 tw-py-0.5 tw-text-[10px] tw-text-slate-500 dark:tw-bg-slate-700 dark:tw-text-slate-300">{label}</span>)}
        </div>
      </div>
    </ButtonBase>
    {pending && <Tooltip title={i18n.t("ticketsList.buttons.accept")}><IconButton className="tw-mr-2 tw-text-messenger-green" aria-label={i18n.t("ticketsList.buttons.accept")} disabled={loading} onClick={accept}>{loading ? <CircularProgress size={20} color="inherit" /> : <Check fontSize="small" />}</IconButton></Tooltip>}
  </li>;
}
